import { createContext, useState } from 'react';

interface DropdownContextType {
    isExpandedContext: boolean;
    setIsExpandedContext: (expanded: boolean) => void;
}
export const DropdownContext = createContext<DropdownContextType>({
    isExpandedContext: false,
    setIsExpandedContext: () => {}
});

export const DropdownProvider = ({ children }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <DropdownContext.Provider value={{ isExpandedContext: isExpanded, setIsExpandedContext: setIsExpanded }}>
            {children}
        </DropdownContext.Provider>
    );
};
